import { createSlice } from '@reduxjs/toolkit'
import { insertFreightRequest,sent_Request,recieve_Request,Request_Approve,ApprovedRequestGet ,DeleteRequest} from '../api/FreightRerquestApi'

const initialState = {
    freightRequest:[],
    sentRequest:[],
    RecieveRequest:[],
    requestApprove:[],
    approvedRequest:[],
    loading:false,
}

export const FreightRequest = createSlice({
  name: 'FreightRequest',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {

    
      builder.addCase(insertFreightRequest.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(insertFreightRequest.fulfilled , (state, action) => {
       
        state.freightRequest=action.payload?.data?.data; 
       
        state.loading = true;
      })
      builder.addCase(insertFreightRequest.rejected, (state, action) => {
        state.loading = false;
      
      })
    

      builder.addCase(sent_Request.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(sent_Request.fulfilled , (state, action) => {
       
        state.sentRequest=action.payload?.data; 
      
      
        state.loading = false;
      })
      builder.addCase(sent_Request.rejected, (state, action) => {
        state.loading = false;
      
      })


      builder.addCase(recieve_Request.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(recieve_Request.fulfilled , (state, action) => {
       
        state.RecieveRequest=action.payload?.data; 
      
       
        state.loading = false;
      })
      builder.addCase(recieve_Request.rejected, (state, action) => {
        state.loading = false;
      
      })

      builder.addCase(Request_Approve.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(Request_Approve.fulfilled , (state, action) => {
    
        state.requestApprove=action.payload; 
        state.loading = false;
      })
      builder.addCase(Request_Approve.rejected, (state, action) => {
        state.loading = false;
      
      })

      builder.addCase(ApprovedRequestGet.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(ApprovedRequestGet.fulfilled , (state, action) => {
    
        state.approvedRequest=action.payload.data; 
        state.loading = false;
      })
      builder.addCase(ApprovedRequestGet.rejected, (state, action) => {
        state.loading = false;
      
      })

      builder.addCase(DeleteRequest.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(DeleteRequest.fulfilled , (state, action) => {
        state.loading = false;
      })
      builder.addCase(DeleteRequest.rejected, (state, action) => {
        state.loading = false;
      
      })
  },

})



export default FreightRequest.reducer